<template>
    <div>
        <Loader />
    </div>
</template>

<script>
import { isReturningFromAuthServer, getAccessToken } from '@/api/auth';
import Loader from '@/components/loader.vue';
import CheckoutService from '@/services/CheckoutService.ts';

export default {
    name: 'oAuthCallback',
    components: { Loader },
    data() {
        return {
            error: '',
        };
    },
    mounted() {
        isReturningFromAuthServer()
            .then(async (hasAuthCode) => {
                if (!hasAuthCode) {
                    console.log('Something wrong...no auth code.');
                }
                await getAccessToken();
                const isNewUser = localStorage.getItem('isNewUser');
                console.log(isNewUser);
                if (isNewUser) {
                    localStorage.removeItem('isNewUser');
                    if (localStorage.getItem('instanceId')) return this.checkout();
                }
                const path = localStorage.getItem('redirect-after-auth');
                localStorage.removeItem('redirect-after-auth');
                console.log('Redirecting to ' + path);
                this.$router.push({
                    path: path != null ? path : '/',
                });
            })
            .catch((potentialError) => {
                if (potentialError) {
                    console.error(potentialError);
                    this.error = potentialError.toString();
                }
            });
    },
    methods: {
        async checkout() {
            const [error, result] = await CheckoutService.checkout(
                localStorage.getItem('instanceId'),
                `https://${window.location.hostname}/payment-success`
            );
            if (error) {
                error.notify();
                return;
            }
            localStorage.setItem('sessionId', result.sessionId);
            localStorage.setItem('sessionIdExpiredAt', result.expiredAt);
            location.replace(result.url);
        },
    },
};
</script>

<style scoped></style>
